var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
// Microscopekit components
import { Button, Card, compose, graphql, GrayText, Grid, GridColumn, PageLayout, RightDiv, Separator, Spinner, withGraphqlErrorFlags, withLoadingSpinner, withMountTracking, withShowFlag, useQuery } from "@atlassiansox/microscopekit";
import { withServiceNotFoundHandler } from "@atlassiansox/microscopekit/dist/src/error/with-service-not-found-handler";
// GraphQL queries
import serviceQuery from "../graphql/service.query.graphql";
// Internal components
import { WargameTemplateList } from "../components/ListView/WargameTemplateListView";
import AddItemIcon from "@atlaskit/icon/glyph/add-item";
import Tabs from "@atlaskit/tabs";
import { lifecycle } from "recompose";
import ServiceWhiteListQuery from "../graphql/service-whitelist.query.graphql";
import { ScheduledWargameTemplates } from "../components/ListView/ScheduledWargameTemplates";
import serviceTemplatesQuery from "../graphql/service-templates.query.graphql";
import SectionMessage from "@atlaskit/section-message";
import { NotificationHeader } from "../components/NotificationHeader";
import { useAnalytics, useSendScreenEvent } from "../analytics";
import { ActiveWargameForService, CreateWargame, RecentWargamesListView, WargameExercisesListView, RecommendedFaults, Announcement } from "../components";
import { SortOrder, WargamesWithFilterQuery } from "../graphql";
var ResiliencePageView = function (props, context) {
    var _a;
    var _b = useQuery(WargamesWithFilterQuery, {
        variables: {
            filter: {
                service: {
                    eq: props.id
                },
                trigger: {
                    in: ["ondemand"]
                }
            },
            limit: 0,
            page: 0,
            sortColumn: "id",
            sortOrder: SortOrder.DESC
        }
    }), wargamesWithFilters = _b.data, isWargameWithFiltersLoading = _b.loading;
    var _c = __read(useState(0), 2), selectedTabIndex = _c[0], setSelectedTabIndex = _c[1];
    var tabs = [
        {
            label: "Active Wargame",
            content: (React.createElement(ActiveWargameForService, { serviceId: props.id, isVisible: selectedTabIndex === 0, trigger: "ondemand" }))
        },
        {
            label: "Wargame Exercises",
            content: React.createElement(WargameExercisesListView, { serviceId: props.id })
        },
        {
            label: "Wargame Plans",
            content: (React.createElement(WargameTemplateList, { serviceId: props.id, warGameTemplateForService: props.serviceTemplatesData.warGameTemplateForService }))
        },
        {
            label: "Scheduled Plans",
            content: (React.createElement(ScheduledWargameTemplates, { serviceId: props.id, warGameTemplateForService: props.serviceTemplatesData.warGameTemplateForService, isVisible: selectedTabIndex === 2 }))
        },
        {
            label: "Recent Wargames",
            content: (React.createElement(RecentWargamesListView, { serviceId: props.id, serviceWargamesData: (_a = wargamesWithFilters === null || wargamesWithFilters === void 0 ? void 0 : wargamesWithFilters.warGamesV2.wargameRows) !== null && _a !== void 0 ? _a : [], isLoading: isWargameWithFiltersLoading, isFilterAvailable: true }))
        }
    ];
    var _d = __read(useState(false), 2), isCreateWargameVisible = _d[0], setIsCreateWargameVisible = _d[1];
    var sendUIEvent = useAnalytics().sendUIEvent;
    useSendScreenEvent("homeScreen");
    var showCreateWargame = function () {
        sendUIEvent({
            source: "homeScreen",
            actionSubject: "button",
            action: "clicked",
            actionSubjectId: "createWargameButton",
            attributes: {}
        });
        setIsCreateWargameVisible(true);
    };
    var hideCreateWargame = function () { return setIsCreateWargameVisible(false); };
    return props.serviceWhiteListData.loading ? (React.createElement(Spinner, null)) : !props.serviceWhiteListData.isValidMvpService ? (React.createElement(PageLayout, { title: "Brahmos" },
        React.createElement(GrayText, null, "Only Micros platform onboarded services are supported by this Framework"),
        React.createElement(Card, null,
            React.createElement("p", null, "Your service is not enrolled in our early access program. Please reach out to #help-brahmos")))) : (React.createElement(PageLayout, { title: "Brahmos" },
        React.createElement("div", null,
            React.createElement(GrayText, null, "Only Micros platform onboarded services are supported by this Framework")),
        React.createElement(Separator, null),
        React.createElement(Grid, null,
            React.createElement(GridColumn, { medium: 12 },
                React.createElement(RightDiv, null,
                    React.createElement(Button, { appearance: "primary", key: "add-item", iconBefore: React.createElement(AddItemIcon, { label: "new-wargame", size: "small" }), onClick: showCreateWargame }, "Create Wargame"),
                    React.createElement(NotificationHeader, { serviceId: props.id })))),
        React.createElement(Separator, null),
        React.createElement(SectionMessage, { appearance: "info" },
            "Refer\u00A0",
            React.createElement("a", { href: "http://go/brahmos-onboarding", target: "_blank", rel: "noopener noreferrer" }, "http://go/brahmos-onboarding"),
            "\u00A0for onboarding to Brahmos"),
        React.createElement(Separator, null),
        React.createElement(Announcement, null),
        React.createElement(Separator, null),
        React.createElement(RecommendedFaults, null),
        React.createElement(Tabs, { tabs: tabs, isContentPersisted: true, selected: selectedTabIndex, onSelect: function (tab, index) { return setSelectedTabIndex(index); } }),
        React.createElement(CreateWargame, { serviceId: props.id, isVisible: isCreateWargameVisible, onHide: hideCreateWargame })));
};
// Use the `compose` function to wrap decorators around your component. These will run before your component code does.
export var ResiliencePage = compose(graphql(serviceQuery, {}), graphql(ServiceWhiteListQuery, {
    name: "serviceWhiteListData",
    options: function (props) { return ({
        query: ServiceWhiteListQuery,
        variables: { serviceId: props.id }
    }); }
}), graphql(serviceTemplatesQuery, {
    name: "serviceTemplatesData",
    options: function (props) { return ({
        query: serviceTemplatesQuery,
        variables: { serviceId: props.id }
    }); }
}), withLoadingSpinner, withShowFlag, withGraphqlErrorFlags, withServiceNotFoundHandler, withMountTracking("Credo.CredoPage"), lifecycle({
    componentDidMount: function () {
        if (!this.props.serviceWhiteListData.loading) {
            this.props.serviceWhiteListData.refetch();
        }
        if (!this.props.serviceTemplatesData.loading) {
            this.props.serviceTemplatesData.refetch();
        }
    }
}))(ResiliencePageView);
